import { useContext, type ReactNode } from 'react';
import { LinkScopeContext } from './link-scope-context';

/** Links in text in here open in dialogs, so they can be walked through without leaving the page. */
export function LinksOpenInDialogs({ children }: { children: ReactNode }) {
  const outer = useContext(LinkScopeContext);
  // Inside the link dialog they keep moving it on, rather than opening another over it.
  if (outer === 'inDialog') return <>{children}</>;
  return <LinkScopeContext.Provider value="dialog">{children}</LinkScopeContext.Provider>;
}

/** The link dialog's own content (LinkDialogHost). */
export function InLinkDialog({ children }: { children: ReactNode }) {
  return <LinkScopeContext.Provider value="inDialog">{children}</LinkScopeContext.Provider>;
}
